<div class="dialog-wrapper">
    <h3>{{ 'Change Password' | translate }}</h3>
    <a mat-icon-button (click)="onNoClick()" class="close">
        <mat-icon class="material-icons-outlined">close</mat-icon>
    </a>
    <div class="dialog-content">
        <form [formGroup]="Form" class="flex-column">
            <mat-form-field appearance="outline">
                <mat-label>{{ 'New Password' | translate }}</mat-label>
                <input matInput formControlName="password" [placeholder]="'Enter Updated Password' | translate" required
                    [type]="hide2 ? 'password' : 'text'">
                <mat-icon matSuffix (click)="hide2 = !hide2">
                    {{hide2 ? 'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>{{ 'Enter OTP' | translate }}</mat-label>
                <input matInput formControlName="otp" [placeholder]="'Enter OTP' | translate" required type="number">
            </mat-form-field>
        </form>
    </div>
    <div class="dialog-footer">
        <div class="btn-row">
            <button mat-button class="a-btn" type="button" (click)="generateOTP()" color="primary">{{ 'Resend otp' |
                translate }}</button>
            <button mat-flat-button class="btn" color="primary" (click)="onChangePassword()"
                [disabled]="!Form.valid || loading">
                <span [class.vHidden]="loading">{{ 'Change password' | translate }}</span>
                <mat-spinner color="primary" *ngIf="loading" diameter="20"></mat-spinner>
            </button>
        </div>
    </div>
    <!-- <p style="text-align: center;" class="success" *ngIf="generateOTPSuccess">{{ 'OTP is successfully sent to your mail id' | translate }}</p> -->
</div>